import axios from "axios"

const checkAuth = () => {
    const token = sessionStorage.getItem("userInfo")
    const PUBLIC_ROUTES = ["login"]

    const isPublicPage = PUBLIC_ROUTES.some( r => window.location.href.includes(r))

    if(!token && !isPublicPage){
        window.location.href = '/login'

    }
    else if (token && isPublicPage){
        window.location.href = '/'

    } else {
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
        }

        axios.interceptors.request.use(function (config) {
            if (config?.notLoading === true) {
                return config
            }
            document.body.classList.add('loading-indicator');
            return config
          }, function (error) {
            return Promise.reject(error);
          });

          axios.interceptors.response.use(function (response) {            
            // response가 file인 경우 header까지 포함된 response 반환
            if (response?.config?.responseType === 'blob') {
              document.body.classList.remove('loading-indicator');
              return response;
            }

            document.body.classList.remove('loading-indicator');
            return response.data;
          }, function (error) {
            if (error.response && error.response.status === 401) {
              sessionStorage.removeItem("userInfo")
              window.location.href = '/login'
            }
            document.body.classList.remove('loading-indicator');
            return Promise.reject(error);
          });
        return token
    }
}

export default checkAuth
